import React from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ClientAccessSettingsProps } from '../../../../ClientAccess.types';
import { currentFinancesSubFeatures, financialPlanSubFeatures } from './Dashboard.meta';
import { useDashboard } from './useDashboard';
import { DashboardFeatureId } from '../../../../../AdviserArea/AdviserArea.types';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';

export const Dashboard: React.FC<ClientAccessSettingsProps> = ({ onChange, ...rest }) => {
  const {
    accessSet,
    isOrionClient,
    dashboardAccessOptions,
    hasDashboardAccess,
    disabledDashboardAccessOptions,
    toggleDashboardAccess,
    toggleSubFeature,
    toggleFeature,
  } = useDashboard({ onChange, ...rest });

  return (
    <section>
      <Toggle
        variant="setting"
        checked={hasDashboardAccess}
        onChange={evt => toggleDashboardAccess(evt.target.checked)}
        my="16"
      >
        Dashboard Access
      </Toggle>

      <Text fontSize="small" color="neutral.500" mt={-12} mb="16">
        Select the items that the user will have access to in their portal instance.
      </Text>

      <Box as="section" pl="24">
        {dashboardAccessOptions.map(({ label: featureName, value: featureId }) => {
          // Current finances sub features
          if (currentFinancesSubFeatures.includes(featureId)) {
            return (
              (isOrionClient || featureId === DashboardFeatureId.NetWorth) && (
                <Toggle
                  key={featureId}
                  variant="setting"
                  checked={accessSet.includes(featureId)}
                  disabled={
                    !hasDashboardAccess ||
                    !accessSet.includes(DashboardFeatureId.CurrentFinances) ||
                    disabledDashboardAccessOptions.includes(featureId)
                  }
                  onChange={evt => toggleSubFeature(evt.target.checked, featureId)}
                  my="16"
                  ml="24"
                >
                  {featureName}
                </Toggle>
              )
            );
          }

          // Financial plan sub features
          if (financialPlanSubFeatures.includes(featureId)) {
            return (
              <Toggle
                key={featureId}
                variant="setting"
                checked={accessSet.includes(featureId)}
                disabled={
                  !hasDashboardAccess ||
                  !accessSet.includes(DashboardFeatureId.FinancialPlan) ||
                  disabledDashboardAccessOptions.includes(featureId)
                }
                onChange={evt => toggleSubFeature(evt.target.checked, featureId)}
                my="16"
                ml="24"
              >
                {featureName}
              </Toggle>
            );
          }

          return (
            <Toggle
              key={featureId}
              variant="setting"
              checked={accessSet.includes(featureId)}
              disabled={!hasDashboardAccess || disabledDashboardAccessOptions.includes(featureId)}
              onChange={evt => toggleFeature(evt.target.checked, featureId)}
              my="16"
            >
              {featureName}
            </Toggle>
          );
        })}
      </Box>
    </section>
  );
};
